import { INIT_PATH } from 'constants/ActionTypes';

export const initPath = path => {
  return {
    type: INIT_PATH,
    payload: path
  };
};
